import { Clipboard } from "@capacitor/clipboard";
import { isNativePlatform } from "./platform";

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof window === "undefined") {
    return false;
  }

  if (isNativePlatform()) {
    await Clipboard.write({ string: text });
    return true;
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  return false;
}
